import { render, staticRenderFns } from "./Datenschutz.vue?vue&type=template&id=6052009b"
import script from "./Datenschutz.vue?vue&type=script&setup=true&lang=ts"
export * from "./Datenschutz.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports